export const Spinner = {
  transclude: true,

  bindings: {
    isLoading: '<',
  },

  template: `
    <i class="fa fa-spin fa-circle-o-notch mr-1" ng-show="$ctrl.isLoading"></i>
    <span ng-transclude></span>`,
};



// WEBPACK FOOTER //
// ./src/components/Spinner/Spinner.js